const duty = {
    getlist: 'duty/getlist-by-admin',
    add: 'duty/add',
    update: 'duty/update',
    remove: 'duty/remove',
    get: 'duty/get-by-admin',
    getall: 'duty/getall',
}
export default duty
